import {
  BASE_URL,
  userRequest,
  COMBO_URL,
  publicRequest,
} from "../requestMethods";
import {
  addServiceStart,
  addServiceSuccess,
  addServiceFailure,
  getServiceStart,
  getServiceSuccess,
  getServiceFailure,
  updateServiceStart,
  updateServiceSuccess,
  updateServiceFailure
} from "../redux/serviceRedux";

import { toast } from "react-toastify";

export const addServices = async (dispatch, labId, data, callback) => {
  console.log("Category Det", data);
  dispatch(addServiceStart());
  try {
    const res = await userRequest.post(
      `labApi/labTestsRoutes/addServicesInLabs/${labId}`,
      data
    );
    console.log("FORM DATA of category", res);
    if (res.status === 200) {
      dispatch(addServiceSuccess(res.data.data));
      console.log("not hitting callback");
      callback(res, true);
    }
  } catch (error) {
    console.log(error, "fhsjkdf");
    toast.error(`Server Error Happens`);
    dispatch(addServiceFailure());
  }
};

export const getLabServices = async (dispatch, labId) => {
  console.log('searchInput', labId)
  dispatch(getServiceStart());
  try {
    const res = await userRequest.post(`labApi/labTestsRoutes/getAllLabTests/${labId}`);
    console.log(res.data, "res.data for cities");
    dispatch(getServiceSuccess(res.data.data));
  } catch (err) {
    dispatch(getServiceFailure());
  }
};

export const getServiceDataById = async (id) => {
  try {
    const res = await userRequest.post(`labApi/labTestsRoutes/getTestData/${id}`);
    console.log(res.data.data, 'res from update get data from id')
    // return
    if (res.status === 200) {
      return res.data.data
    }
  }
  catch (err) {
    console.log(err, 'err at get test id data')
    toast.error(`Server Error Happens`);
  }
}


export const updateService = async (dispatch, id, service, callback) => {
  dispatch(updateServiceStart());
  try {
    const res = await userRequest.patch(`labApi/labTestsRoutes/updateTestData/${id}`, service);
    console.log("res data", res.data);
    dispatch(updateServiceSuccess(res.data));
    callback(res, true)
  } catch (err) {
    console.log("product err", err);
    toast.error(`Server Error Happens`);
    dispatch(updateServiceFailure());
  }
};

export const updateServiceStatus = async (dispatch, id, service, callback) => {
  // console.log('service========>>>>>>', service);
  // console.log('id=========>>>>>>', id);

  try {
    const res = await userRequest.patch(`labApi/labTestsRoutes/updateTestDataStatus/${id}`, service);
    console.log("res data", res.data);
    callback(res, true)
  } catch (err) {
    console.log("product err", err);
    toast.error(`Server Error Happens`);
  }
};

export const updateServiceFeature = async (dispatch, id, service, callback) => {
  try {
    const res = await userRequest.patch(`labApi/labTestsRoutes/updateTestDataFeature/${id}`, service);
    console.log("res data", res.data);
    callback(res, true)
  } catch (err) {
    console.log("product err", err);
    toast.error(`Server Error Happens`);
  }
};